import React from 'react'

const Interview_Mock_Test_1C = () => {
  return (
    <div>
      <h1>Mock Test 3</h1>
    </div>
  )
}

export default Interview_Mock_Test_1C
